import lodash from "lodash";
import { rpFormat } from "./RewriteParagraphSaga";
import { repopulate, setRpErrMsg } from "./RewriteParagraphUtils";

// TYPES

// export const AI_DESC_RP_UPDATE_ORDER_ID = "AI_DESC_RP_UPDATE_ORDER_ID";
export const AI_DESC_RP_UPDATE_TONE = "AI_DESC_RP_UPDATE_TONE";
export const AI_DESC_RP_HANDLE_REPOPULATE_PARAGRAPH = "AI_DESC_RP_HANDLE_REPOPULATE_PARAGRAPH";
export const AI_DESC_RP_HANDLE_TONE_DROPDOWN_OPEN = "AI_DESC_RP_HANDLE_TONE_DROPDOWN_OPEN";
export const AI_DESC_RP_UPDATE_DETAILS = "AI_DESC_RP_UPDATE_DETAILS";
export const AI_DESC_RP_UPDATE_REWRITE_PARAGRAPH = "AI_DESC_RP_UPDATE_REWRITE_PARAGRAPH";
export const AI_DESC_RP_UPDATE_REWRITE_PARAGRAPH_ISEDITING =
    "AI_DESC_RP_UPDATE_REWRITE_PARAGRAPH_ISEDITING";
export const AI_DESC_RP_GENERATE_REWRITE_PARAGRAPH = "AI_DESC_RP_GENERATE_REWRITE_PARAGRAPH";
export const AI_DESC_RP_REGENERATE_REWRITE_PARAGRAPH = "AI_DESC_RP_REGENERATE_REWRITE_PARAGRAPH";
export const AI_DESC_RP_HANDLE_ACTION_REWRITE_PARAGRAPH = "AI_DESC_RP_HANDLE_ACTION_REWRITE_PARAGRAPH";
export const AI_DESC_RP_FETCH_REWRITE_PARAGRAPH = "AI_DESC_RP_FETCH_REWRITE_PARAGRAPH";
export const AI_DESC_RP_UNDO_REWRITE_PARAGRAPH = "AI_DESC_RP_UNDO_REWRITE_PARAGRAPH";
export const AI_DESC_RP_UPDATE_PAGE_TYPE = "AI_DESC_RP_UPDATE_PAGE_TYPE";
export const AI_DESC_RP_UPDATE_ACTION_REWRITE_PARAGRAPH = "AI_DESC_RP_UPDATE_ACTION_REWRITE_PARAGRAPH";
export const AI_DESC_RP_CLEAR = "AI_DESC_RP_CLEAR";
export const AI_DESC_RP_HANDLE_SEVER_BUSY_POPUP = "AI_DESC_RP_HANDLE_SEVER_BUSY_POPUP";

// ACTIONS

export const handleRpToneDdOpen = (payload) => ({
    type: AI_DESC_RP_HANDLE_TONE_DROPDOWN_OPEN,
    payload,
});

export const updateRpTone = (payload) => ({
    type: AI_DESC_RP_UPDATE_TONE,
    payload,
});

export const updateRpDetails = (payload) => ({
    type: AI_DESC_RP_UPDATE_DETAILS,
    payload,
});

export const updateRpDesc = (payload) => ({
    type: AI_DESC_RP_UPDATE_REWRITE_PARAGRAPH,
    payload,
});

export const updateRpDescIsEditing = (payload) => ({
    type: AI_DESC_RP_UPDATE_REWRITE_PARAGRAPH_ISEDITING,
    payload,
});

export const fetchRewriteParagraph = (payload) => ({
    type: AI_DESC_RP_FETCH_REWRITE_PARAGRAPH,
    payload,
});

export const handleRewriteParagraphUndo = (payload) => ({
    type: AI_DESC_RP_UNDO_REWRITE_PARAGRAPH,
    payload,
});

export const updateActionRewriteParagraph = (payload) => ({
    type: AI_DESC_RP_UPDATE_ACTION_REWRITE_PARAGRAPH,
    payload,
});

export const updateRpPageType = (payload) => ({
    type: AI_DESC_RP_UPDATE_PAGE_TYPE,
    payload,
});

export const handleRepopulateParagraph = (payload) => ({
    type: AI_DESC_RP_HANDLE_REPOPULATE_PARAGRAPH,
    payload,
});

export const clearRewriteParagraphDetails = (payload) => ({
    type: AI_DESC_RP_CLEAR,
    payload,
});

export const handleRpSeverBusyPopup = (payload) => ({
    type: AI_DESC_RP_HANDLE_SEVER_BUSY_POPUP,
    payload,
});

// Actions to trigger saga generators

export const generateRewriteParagraph = (payload) => ({
    type: AI_DESC_RP_GENERATE_REWRITE_PARAGRAPH,
    payload,
});

export const regenerateRewriteParagraph = (payload) => ({
    type: AI_DESC_RP_REGENERATE_REWRITE_PARAGRAPH,
    payload,
});

export const handleActionRewriteParagraph = (payload) => ({
    type: AI_DESC_RP_HANDLE_ACTION_REWRITE_PARAGRAPH,
    payload,
});

// REDUCER

export const INITIAL_STATE = {
    order_id: `${Date.now() + Math.floor(Math.random() * 100)}`,
    tone: {
        title:"Select tone",
        defaultTitle:"Select tone",
        dropDownList: [
            "Select tone",
            "Inspirational",
            "Professional",
            "Hopeful",
            "Regretful",
            "Assertive",
            "Joyful",
            "Persuasive",
            "Formal",
            "Informal",
            "Courteous",
            "Respectful",
            "Concise",
            "Contemplative",
            "Friendly",
            "Excited",
        ],
        selectedItem: "",
        isOpen:false,
    },
    mainPoints: "",
    paragraphGenerated: [
        // {
        //     status: "Just now",
        //     generatedDesc:
        //         "application\n\n\n\nHello, \n\nI am writing to inform you that I am going to be taking a leave of absence from work. I will be gone for two weeks starting on Monday. Thank you for understanding and I hope everything goes well while I'm away. \n\nSincerely, \n[Your Name]",
        //         editedDesc: "",
        //     isEditing: false,
        //     isEdited: false,
        //     liked: null,
        //     generated_at: Date.now(),
        // },
    ],
    repopulate:false,
    isRewriteParagraphBtnHidden: false,
    isRewriteParagraphBtnDisabled: true,
    isParagraphGenerating: false,
    errMsg: "Please fill the required fields.",
    pageType: "Paragraph Generation",
    popups:{
        busyServer:{
            show:false,
        }
    },
};

const RewriteParagraphReducer = (
    state = lodash.cloneDeep(INITIAL_STATE),
    action
) => {
    switch (action.type) {
        case AI_DESC_RP_CLEAR: {
            let temp_state = lodash.cloneDeep(INITIAL_STATE);
            temp_state.order_id = `${
                Date.now() + Math.floor(Math.random() * 100)
            }`;
            return { ...temp_state };
        }
        case AI_DESC_RP_HANDLE_TONE_DROPDOWN_OPEN: {
            const { isOpen } = action.payload;
            let temp_state = { ...state };
            temp_state.tone.isOpen=isOpen
            return {
                ...temp_state,
            };
        }
        case AI_DESC_RP_UPDATE_TONE: {
            const { tone } = action.payload;
            let temp_state = { ...state };
            let toneObj = temp_state["tone"];
            if (toneObj["defaultTitle"] == tone){
                toneObj["selectedItem"] = "";
                toneObj["title"] = toneObj["defaultTitle"];
            }else{
                toneObj["selectedItem"] = tone;
                toneObj["title"]=tone
            }
            temp_state.isRewriteParagraphBtnHidden = false;
            setRpErrMsg(temp_state);
            return {
                ...temp_state,
            };
        }
        case AI_DESC_RP_UPDATE_DETAILS: {
            const { details } = action.payload;
            let temp_state = { ...state };
            temp_state["mainPoints"] = details;
            temp_state.isRewriteParagraphBtnHidden = false;
            setRpErrMsg(temp_state);
            return {
                ...temp_state,
            };
        }
        case AI_DESC_RP_UPDATE_REWRITE_PARAGRAPH: {
            const { descInd, desc } = action.payload;
            let temp_state = { ...state };
            let emailGen = temp_state.paragraphGenerated;
            emailGen[descInd]["editedDesc"] = desc;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_RP_UPDATE_REWRITE_PARAGRAPH_ISEDITING: {
            const { isEditing, descInd } = action.payload;
            let temp_state = { ...state };
            let emailGen = temp_state.paragraphGenerated;
            // let genDesc = emailGen[descInd]["generatedDesc"];
            // let edDesc = emailGen[descInd]["editedDesc"];
            // if (edDesc !== genDesc && edDesc!=="") {
            //     emailGen[descInd]["isEdited"] = true;
            // }else{
            //     emailGen[descInd]["isEdited"] = false;
            // }
            emailGen[descInd]["isEditing"] = isEditing;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_RP_FETCH_REWRITE_PARAGRAPH: {
            let temp_state = { ...state };
            const {paragraphs} = action.payload
            temp_state.isRewriteParagraphBtnHidden = true;
            temp_state.paragraphGenerated = paragraphs;
            temp_state["isParagraphGenerating"] = false;
            temp_state["pageType"] = "Generated Section";
            temp_state.repopulate=false
            return {
                ...temp_state,
            };
        }
        case AI_DESC_RP_UPDATE_ACTION_REWRITE_PARAGRAPH: {
            const { descInd, actionInfo,isEdited } = action.payload;
            let temp_state = { ...state };
            let emailDesc = temp_state.paragraphGenerated;
            Object.keys(actionInfo).forEach((actKey) => {
                emailDesc[descInd][actKey] = actionInfo[actKey];
            });
            emailDesc[descInd]["isEdited"] = isEdited;
            emailDesc[descInd]["isEditing"] = false;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_RP_UNDO_REWRITE_PARAGRAPH: {
            const { descInd } = action.payload;
            let temp_state = { ...state };
            let emailDesc = temp_state.paragraphGenerated;
            emailDesc[descInd]["editedDesc"] =
                emailDesc[descInd]["description_generated"];
            emailDesc[descInd]["isEditing"] = false;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_RP_GENERATE_REWRITE_PARAGRAPH: {
            let temp_state = { ...state };
            temp_state["isParagraphGenerating"] = true;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_RP_REGENERATE_REWRITE_PARAGRAPH: {
            let temp_state = { ...state };
            temp_state["isParagraphGenerating"] = true;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_RP_UPDATE_PAGE_TYPE: {
            const { pageType } = action.payload;
            let temp_state = { ...state };
            temp_state.pageType = pageType;
            return {
                ...temp_state,
            };
        }
        case AI_DESC_RP_HANDLE_REPOPULATE_PARAGRAPH: {
            const { data } = action.payload;
            let temp_state = { ...state };
            repopulate(temp_state,data)
            setRpErrMsg(temp_state);
            return {
                ...temp_state,
            };
        }
        case AI_DESC_RP_HANDLE_SEVER_BUSY_POPUP: {
            let temp_state = { ...state };
            const {isShow} = action.payload
            temp_state.popups.busyServer.show=isShow
            return {
                ...temp_state,
            };
        }
        default:
            return state;
    }
};

export default RewriteParagraphReducer;
